import { Spinner } from '@chakra-ui/react';
import { ClipText } from './ClipText';
import { SubAccountResponse } from 'api/bindings/SubAccountResponse';

export interface SubAccountLabelProps {
  value: SubAccountResponse | undefined;
}

export const SubAccountLabel = (props: SubAccountLabelProps) => {
  const { value } = props;

  if (!value) {
    return <Spinner size="xs" />;
  }

  return <ClipText text={value?.fullSubAccountName} />;
};
